import AxiosInstance from "../interceptor/interceptor";

//#region - Usuarios
const postLoginURL = '/users/login/';
const postGoogleLoginURL = '/users/google-login/';
const postLogoutURL = '/users/logout/';
const postRegisterURL = '/users/create-customer/';
const getRetrieveUserURL = '/users/retrieve-user/';
const postConfirmUserURL = '/users/confirm-user/';
const getValidateUsernameURL = '/users/validate-username/';
const postPasswordRecoverURL = '/users/password-recover/';
const putResetPasswordURL = '/users/';
const postUpdateProfessionalURL = '/users/update-professional-data/';
const postConfirmProfessionalURL = '/users/confirm-professional-data/';

const getAllUsersURL = '/users/';
const getUserDetailURL = '/users/get-user-detail/';

export const postLogin = async (param) => {
  return AxiosInstance.post(`${postLoginURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const postGoogleLogin = async (param) => {
  param = {"google_id":param.data.id,"google_mail":param.data.email,"google_name":param.data.name, google_img:param.data.picture}
  return AxiosInstance.post(`${postGoogleLoginURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};


export const postLogout = async (param) => {
  return AxiosInstance.post(`${postLogoutURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postRegister = async (param) => {
  return AxiosInstance
    .post(`${postRegisterURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getRetrieveUser = async (param) => {
  return AxiosInstance
    .get(`${getRetrieveUserURL}?retrieve_user_id=${param?.user_id}&user_id=${param?.user_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postConfirmUser = async (param) => {
  return AxiosInstance
    .post(`${postConfirmUserURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getValidateUsername = async (username) => {
  return AxiosInstance
    .get(`${getValidateUsernameURL}?username=${username}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postPasswordRecover = async (param) => {
  return AxiosInstance
    .post(`${postPasswordRecoverURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const putResetPassword = async (param) => {
  return AxiosInstance
    .put(`${putResetPasswordURL}${param?.user_id}/reset-pass/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postUpdateProfessional = async (param) => {
  return AxiosInstance
    .post(postUpdateProfessionalURL, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postConfirmProfessional = async (param) => {
  return AxiosInstance
    .post(postConfirmProfessionalURL, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllUsers = async (param) => {

  let url = `${getAllUsersURL}?page=${param?.page}&&count=${param?.count}&&user_id=${param?.user_id}`
  if (param.searcher != null){ url += `&&searcher=${param?.searcher}` }
  if (param.is_profesional_confirmed != null){ url += `&&is_profesional_confirmed=${param?.is_profesional_confirmed}` }
  if (param.profesional_data != null){ url += `&&profesional_data=${param?.profesional_data}` }

  return AxiosInstance
    .get(url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUserDetail = async (param) => {
  return AxiosInstance
    .get(`${getUserDetailURL}?retrieve_user_id=${param?.retrieve_user_id}&user_id=${param?.user_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//#endregion

//#region - Productos
const getProductsURL = '/products/';
const getProductsAdminURL = '/products/products-admin/';
const postProductsURL = '/products/';
const postChangeProductPriceMasiveURL = '/products/change-products-price/';
const postProductsIGENURL = '/products/product-resource-subcategory/';
const putProductsURL = '/products/';
const getProductByCategoryURL = '/products/products-by-category/';
const getProductBySubcategoryURL = '/products/products-by-subcategory/';
const getProductIdURL = '/products/';
const postCreateImageURL = '/products/create-image/';
const getSearcherProductsURL = '/products/searcher-products/';
const putProductChangeStatusURL = '/products/change-status/';
const getSearcherProductsAdminURL = '/products/searcher-product-admin/';

export const getProducts = async (param) => {
  return AxiosInstance
    .get(`${getProductsURL}?` +
      (param?.page !== undefined ? `page=${param?.page}&` : '') +
      (param?.count !== undefined ? `count=${param?.count}` : '')
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProductsAdmin = async (param) => {
  return AxiosInstance
  .get(`${getProductsAdminURL}?user_id=${param?.user_id}` +
    (param?.search !== undefined ? `&searcher=${param?.search}` : '') +
    (param?.brand_id !== undefined ? `&brand_id=${param?.brand_id}` : '') +
    (param?.page !== undefined ? `&page=${param?.page}` : '') +
    (param?.count !== undefined ? `&count=${param?.count}` : '')
  )
  .then((response) => {return response;})
  .catch((error) => {throw error;});
};

export const postProducts = async (param) => {
  return AxiosInstance
    .post(`${postProductsURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postProductsIGEN = async (param) => {
  return AxiosInstance
    .post(`${postProductsIGENURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const putProducts = async (param) => {
  return AxiosInstance
    .put(`${putProductsURL}${param.id}/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProductsByCategory = async (param) => {
  return AxiosInstance
    .get(`${getProductByCategoryURL}?category_id=${param?.category_id}&&page=${param?.page}&&count=${param?.count}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProductsBySubcategory = async (param) => {
  return AxiosInstance
    .get(`${getProductBySubcategoryURL}?subcategory_id=${param?.subcategory_id}&&page=${param?.page}&&count=${param.count}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProductId = async (param) => {
  return AxiosInstance
    .get(`${getProductIdURL}${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postCreateImage = async (param) => {
  return AxiosInstance
    .post(`${postCreateImageURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSearcherProducts = async (param) => {
  return AxiosInstance
    .get(`${getSearcherProductsURL}?searcher=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const putProductChangeStatus = async (param) => {
  return AxiosInstance
    .put(`${putProductChangeStatusURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSearcherProductsAdmin = async (param) => {
  return AxiosInstance
    .get(`${getSearcherProductsAdminURL}?user_id=${param?.user_id}` +
      (param?.search !== undefined ? `&search=${param?.search}` : '') +
      (param?.brand_id !== undefined ? `&brand_id=${param?.brand_id}` : '') +
      (param?.page !== undefined ? `&page=${param?.page}` : '') +
      (param?.count !== undefined ? `&count=${param?.count}` : '')
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postChangeProductPriceMasive = async (param) => {
  return AxiosInstance
    .post(`${postChangeProductPriceMasiveURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//#endregion

//#region - Categorias
const getCategoriesURL = '/category/';
const getCategoriesSubcategoriesURL = '/category/get-category-subcategory/';
const postCategoryURL = '/category/';
const putCategoryURL = '/category/';
const deleteCategoryURL = '/category/delete-category/';
const getCategorySubcategoriesURL = '/category/get-categorysXsubcategorys/';
const postCreateCategorySubcategoryURL = '/category/create-category-subcategory/';

export const getCategories = async () => {
  return AxiosInstance
    .get(`${getCategoriesURL}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCategoriesSubcategories = async () => {
  return AxiosInstance
    .get(`${getCategoriesSubcategoriesURL}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postCategory = async (param) => {
  return AxiosInstance
    .post(`${postCategoryURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const putCategory = async (param) => {
  return AxiosInstance
    .put(`${putCategoryURL}${param.id}/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const deleteCategory = async (param) => {
  return AxiosInstance
    .delete(`${deleteCategoryURL}`, { data: param })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCategorySubcategories = async (param) => {
  return AxiosInstance
    .get(`${getCategorySubcategoriesURL}?category_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postCreateCategorySubcategory = async (param) => {
  return AxiosInstance
    .post(`${postCreateCategorySubcategoryURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion

//#region - SubCategorias
const getSubCategoriesURL = '/subcategory/';
const postSubCategoryURL = '/subcategory/';
const putSubCategoryURL = '/subcategory/';
const deleteSubCategoryURL = '/subcategory/delete-subcategory/';

export const getSubCategories = async () => {
  return AxiosInstance
    .get(`${getSubCategoriesURL}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postSubCategory = async (param) => {
  return AxiosInstance
    .post(`${postSubCategoryURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const putSubCategory = async (param) => {
  return AxiosInstance
    .put(`${putSubCategoryURL}${param.id}/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const deleteSubCategory = async (param) => {
  return AxiosInstance
    .delete(`${deleteSubCategoryURL}`, { data: param })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion

//#region - Envios
const postQuantityPackageURL = '/shipping/quantity-package/';
const putManualUpdateShippingURL = '/shipping/manual-update-shipping/';
const getQuoteShippingURL = '/shipping/quote-shipping/';

export const postQuantityPackage = async (param) => {
  return AxiosInstance
    .post(`${postQuantityPackageURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const putManualUpdateShipping = async (param) => {
  return AxiosInstance
    .put(`${putManualUpdateShippingURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getQuoteShipping = async (param) => {
  return AxiosInstance
    .get(`${getQuoteShippingURL}?user_id=${param.user_id}&zip_code=${param.zip_code}`,)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion

//#region - Domicilio
const postAddressURL = '/address/';
const getProvincesURL = '/address/provinces/';
const getAddresIdURL = '/address/';

export const postAddress = async (param) => {
  return AxiosInstance
    .post(`${postAddressURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProvinces = async () => {
  return AxiosInstance
    .get(`${getProvincesURL}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAddresId = async (param) => {
  return AxiosInstance
    .get(`${getAddresIdURL}address-by-user/?user_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion

//#region - Ordenes
const postOrdersURL = '/orders/';
const getOrdersURL = '/orders/';
const getOrderCustomerURL = '/orders/get-order-customer/';
const getOrderDetailURL = '/orders/get-order-detail/';

export const postOrders = async (param) => {
  return AxiosInstance
    .post(`${postOrdersURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrders = async (param) => {
  return AxiosInstance
    .get(`${getOrdersURL}?user_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderCustomer = async (param) => {
  return AxiosInstance
    .get(`${getOrderCustomerURL}?user_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderDetail = async (param) => {
  return AxiosInstance
    .get(`${getOrderDetailURL}?user_id=${param?.user_id}&order_id=${param?.order_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion

//#region - Marcas
const getBrandURL = '/brand/';
const postBrandURL = '/brand/';
const putBrandURL = '/brand/';
const postBrandChangeStatusURL = '/brand/change-brand-status/';

export const getBrand = async (param) => {
  return AxiosInstance
    .get(`${getBrandURL}?user_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const postBrand = async (param) => {
  return AxiosInstance
    .post(`${postBrandURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const putBrand = async (param) => {
  let id = param.id;
  delete param.id;
  return AxiosInstance
    .put(`${putBrandURL}${id}/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};

export const postBrandChangeStatus = async (param) => {
  return AxiosInstance
    .post(`${postBrandChangeStatusURL}`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};
//#endregion

//#region - Imagenes
const deleteImageProductURL = '/resource/delete-image-product/';

export const deleteImageProduct = async (param) => {
  return AxiosInstance
    .delete(`${deleteImageProductURL}`, { data: param })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    })
};
//#endregion

//#region - Estadisticas
const getStatisticsURL = '/statistic/';

export const getStatistics = async (param) => {
  return AxiosInstance
    .get(`${getStatisticsURL}?user_id=${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//#region - Prescripciones
const prescriptionURL = '/prescription/';

export const postPrescription = async (param) => {
  return AxiosInstance
    .post(prescriptionURL, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const postPrintPrescription = async (param) => {
  return AxiosInstance
    .post(`${prescriptionURL}generate-prescription-pdf/`, param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllPrescriptions = async (param) => {
  return AxiosInstance
    .get(`${prescriptionURL}?page=${param?.page}&&count=${param?.count}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDetailPrescription = async (param) => {
  return AxiosInstance
    .get(`${prescriptionURL}${param?.prescription_id}/`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
//#endregion
